import { TooltipCellConfig } from '../General/Table/table-ui-types';
import { ISubscriptionRowData } from '../../types/subscription';

export const subscriptionRowCellConfig: TooltipCellConfig<ISubscriptionRowData>[] = [
  { title: 'Subscription ID', propertyKey: 'subscriptionId', width: 2, showTooltip: false },
  { title: 'System', propertyKey: 'system', width: 1, showTooltip: false },
  { title: 'Role', propertyKey: 'roleName', width: 1, showTooltip: false },
];
